export type SummarizationPromptInput = {
  referenceNumber: string
  messages: Array<{
    role: 'line_manager' | 'expert' | 'system'
    body: string
  }>
  projectName?: string
  issueCategory?: string
  affectedSystem?: string
  actionRequested?: string
}

export function buildSummarizationPrompt(input: SummarizationPromptInput): {
  system: string
  user: string
} {
  const thread = input.messages
    .map((message, index) => {
      return `Message ${index + 1} (${message.role}):\n${message.body}`
    })
    .join('\n\n')

  const structuredFields = [
    input.projectName && `Project: ${input.projectName}`,
    input.issueCategory && `Issue category: ${input.issueCategory}`,
    input.affectedSystem && `Affected system: ${input.affectedSystem}`,
    input.actionRequested && `Action requested: ${input.actionRequested}`,
  ].filter(Boolean).join('\n')

  const titleHint = input.issueCategory && input.projectName
    ? `Title format example: "[${input.issueCategory}] <brief problem> — ${input.projectName} project"`
    : 'The title should be specific enough to scan in an inbox.'

  return {
    system: [
      'You summarize maintenance support tickets for expert reviewers.',
      'Return concise, operationally useful JSON only.',
      titleHint,
      'The summary should include the problem, affected asset if known, symptoms, timeline, attempted remedies, and impact.',
      'If details are missing, say that plainly without inventing facts.',
      'The reasoning_trace should briefly explain what evidence in the thread supports the summary.',
    ].join(' '),
    user: [
      `Ticket reference: ${input.referenceNumber}`,
      structuredFields ? `\nStructured intake fields:\n${structuredFields}` : '',
      '',
      'Conversation thread:',
      thread,
    ].filter((line) => line !== '').join('\n'),
  }
}
